import { FeedbackRowType } from '../types';
import { AbstractRowBuilder } from './AbstractRowBuilder';

export class StarRowBuilder extends AbstractRowBuilder<FeedbackRowType.Star> {
  constructor(id: string) {
    super(id, FeedbackRowType.Star);
  }

  withTooltips(tooltips: [string, string, string, string, string]) {
    this.patch({
      tooltips,
    });
  }

  override isValid() {
    const { tooltips } = this.state();

    const validation = this.createValidationResponse().withParentValidation(
      super.isValid(),
    );

    if (tooltips?.length) {
      validation.withCheck('should be exactly 5 tooltips', () => {
        return tooltips?.length === 5;
      });
    }

    return validation.validate();
  }
}
